export default __webpack_public_path__ + "static/media/doc.0561db99.png";